
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TrashIcon',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '18'
    },
    height: {
      type: String,
      default: '18'
    }
  },
  computed: {
    color(): string {
      return this.disabled
        ? this.$whitelabel.lightTheme.textPrimary.lighten4
        : this.$whitelabel.lightTheme.buttonHighlightError.base;
    }
  }
});
